import React, { useState } from 'react';

const RescheduleBooking = () => {
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for rescheduling logic
    console.log(`Rescheduled to ${newDate} at ${newTime}`);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 bg-white shadow-md rounded-lg">
      <h1 className="text-lg font-bold">Reschedule Your Booking</h1>
      <input
        type="date"
        value={newDate}
        onChange={(e) => setNewDate(e.target.value)}
        className="border p-2 rounded my-2 w-full"
      />
      <input
        type="time"
        value={newTime}
        onChange={(e) => setNewTime(e.target.value)}
        className="border p-2 rounded my-2 w-full"
      />
      <button type="submit" className="bg-blue-500 text-white p-2 rounded">
        Reschedule
      </button>
    </form>
  );
};

export default RescheduleBooking;
